/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockValidationTypeFields.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Validation Field Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, September 25, 2018 - 08:08:25 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/25/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const VALIDATIONFIELD_LIST_CONTAINER_LOADED = 'VALIDATIONFIELD_LIST_CONTAINER_LOADED';
export const VALIDATIONFIELD_LIST_CONTAINER_UNLOADED = 'VALIDATIONFIELD_LIST_CONTAINER_UNLOADED';
export const VALIDATIONFIELD_LIST_TABLE_LOADED = 'VALIDATIONFIELD_LIST_TABLE_LOADED';
export const VALIDATIONFIELD_LIST_TABLE_UNLOADED = 'VALIDATIONFIELD_LIST_TABLE_UNLOADED';

export const VALIDATIONFIELD_SELECT_ROW = 'VALIDATIONFIELD_SELECT_ROW';

export const VALIDATIONFIELD_ADD = 'VALIDATIONFIELD_ADD';
export const VALIDATIONFIELD_EDIT = 'VALIDATIONFIELD_EDIT';
export const VALIDATIONFIELD_DELETE = 'VALIDATIONFIELD_DELETE';
export const VALIDATIONFIELD_OPEN_WARNING = 'VALIDATIONFIELD_OPEN_WARNING';
export const VALIDATIONFIELD_CLOSE_WARNING = 'VALIDATIONFIELD_CLOSE_WARNING';

export const VALIDATIONFIELD_EDIT_CONTAINER_LOADED = 'VALIDATIONFIELD_EDIT_CONTAINER_LOADED';
export const VALIDATIONFIELD_EDIT_CONTAINER_UNLOADED = 'VALIDATIONFIELD_EDIT_CONTAINER_UNLOADED';
export const VALIDATIONFIELD_EDIT_FORM_LOADED = 'VALIDATIONFIELD_EDIT_FORM_LOADED';
export const VALIDATIONFIELD_EDIT_FORM_UNLOADED = 'VALIDATIONFIELD_EDIT_FORM_UNLOADED';

export const VALIDATIONFIELD_SET_DATATYPE_SELECT = 'VALIDATIONFIELD_SET_DATATYPE_SELECT';
export const VALIDATIONFIELD_EDIT_DATA_LOAD = 'VALIDATIONFIELD_EDIT_DATA_LOAD';

export const VALIDATIONFIELD_EDIT_CONTAINER_SUBMIT = 'VALIDATIONFIELD_EDIT_CONTAINER_SUBMIT';
export const VALIDATIONFIELD_EDIT_CONTAINER_CANCEL = 'VALIDATIONFIELD_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockValidationTypeFields.js